module.exports = __webpack_public_path__ + "static/img/ser.d23e665.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ser.jpg
// module id = m7tZ
// module chunks = 14